import React from "react";
import check from "../../images/hireDeveloper/check.svg";
import { skillData } from "./constdata";

const Skill = ({ data, anotherSkill, onSave }) => {
  const onIconSelect = (id) => {
    if (data.includes(id))
      onSave(
        "skill",
        data.filter((a) => a !== id)
      );
    else if (id === 11) onSave("skill", [id]);
    else if (id !== 11) onSave("skill", [...data.filter((a) => a !== 11), id]);
  };
  return (
    <>
      <section className="skillSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>1. Select Skills You Are Looking To Hire?</h4>
              </div>
            </div>
          </div>
          <div className="row">
            {skillData.map((m) => (
              <div className="col-lg-2 col-md-3 col-sm-3 col-6 mb-4" key={m.id}>
                <div
                  className={`techIcon ${data.includes(m.id) ? "active" : ""}`}
                  onClick={() => onIconSelect(m.id)}
                >
                  <img src={m.images} alt={m.altText} />
                  <p>{m.name}</p>
                  <div className="checkBox">
                    <img src={check} alt="Remote Developer" />
                  </div>
                </div>
              </div>
            ))}

            <div
              className={`col-lg-2 col-md-3 col-sm-3 skillForm ${
                data.includes(11) ? "d-flex" : "d-none"
              }`}
            >
              <form className="form-inline d-block d-sm-flex">
                <div className="form-group mb-0">
                  <input
                    type="text"
                    className="form-control"
                    name="needhelp"
                    placeholder="Enter the skills you're looking for"
                    value={anotherSkill}
                    onChange={(e) => onSave("anotherSkill", e.target.value)}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Skill;
